import Vue, { VNode } from 'vue';
import { LinkClickEvent, InternalCampaignEvent } from '@/services/analytics/events';
import { WebInteraction } from '@/services/analytics/platforms/adobe-analytics/models';
import { DirectiveBinding } from 'vue/types/options';

Vue.directive('track-link-click', {
  inserted(el, binding, vnode) {
    el.addEventListener('click', e => {
      let webInteraction = getLinkClickedBaseData(getLinkName(el, binding), formatLinkModuleName(el, binding, vnode));
      
      switch (binding.arg) {
        case 'socialshare':
          webInteraction.socialShareClicks = {value: 1 };
          webInteraction.socialName = formatLinkModuleName(el, binding, vnode);
          webInteraction.socialPlatform = 'Twitter';
          break;
        case 'social':
          webInteraction.socialFollowClicks = { value: 1 };
          webInteraction.socialPlatform = vnode.data?.attrs?.href;       
          break;
        case 'ic':
          vnode.context?.$services.analytics.send(new InternalCampaignEvent(formatLinkModuleName(el, binding, vnode)));
          return;
        case 'cta':
          webInteraction.ctaClicks = { value: 1 };
          webInteraction.ctaNameType = formatLinkModuleName(el, binding, vnode);
          break;
      }      
      vnode.context?.$services.analytics.send((new LinkClickEvent(webInteraction) as unknown) as LinkClickEvent);
    });
  },
});

function getLinkClickedBaseData(linkName: string, linkModuleName: string): WebInteraction {
  return {
    linkClicks: { value: 1 },
    linkModuleName,
    name: linkName,
    type: 'other',
  };
}

// Attempt to get as much of the necessary data from the DOM.
// The proposed structure of that data that will be sent: "parent component | element's component | link name"
function formatLinkModuleName(el: HTMLElement, binding: DirectiveBinding, vnode: VNode): string {
  // Get parent component
  const parentComponent =
    vnode.parent?.context?.$vnode?.componentOptions?.tag ||
    vnode.componentInstance?.$parent?.$vnode.componentOptions?.tag ||
    vnode.context?.$parent?.$vnode.componentOptions?.tag;

  // Get component where clicked element lives. This could be cmg-button, for example
  const currentComponent = vnode.parent?.componentOptions?.tag || vnode.componentOptions?.tag || vnode.context?.$vnode.componentOptions?.tag;

  return `${parentComponent ?? ''}${parentComponent ? '|' : ''}${currentComponent}|${getLinkName(el, binding)}`;
}

// Pass an arg to the directive if there isn't any innertext.
function getLinkName(el: HTMLElement, binding: DirectiveBinding): string {
  return el.innerText || binding.arg || '';
}
